import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowBack, DeleteOutline } from "@mui/icons-material";
import Checkout from "../../Checkout";
import { Card, Rating, Skeleton } from "@mui/material";
import { myWishListFn } from "../../../Services/Products/Wishlist";
import { useMutation, useQuery, useQueryClient } from "react-query";
import classNames from "classnames";
import WishlistButton from "../../../Shared/WishlistButton";
import { removeWishListFn } from "../../../Services/Products/RemoveFromWishlist";
import { setSnackbar } from "../../../Redux/Actions/SnackBar";
import { useDispatch } from "react-redux";
import SearchModal from "../../../Shared/Search";

const MyWishList = () => {
  const navigate = useNavigate();
  const { data: myWishList, isLoading } = useQuery(
    ["myWishList"],
    () => myWishListFn(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );
  const client = useQueryClient();
  const dispatch = useDispatch();
  const { mutate: remove } = useMutation(removeWishListFn, {
    onSuccess: (response) => {
      dispatch(
        setSnackbar({
          open: true,
          message: response.data.msg,
          variant: "success",
        })
      );
      response.data.msg === "Product is deleted from wishlist !!!" &&
        client.refetchQueries("myWishList");
    },
  });

  const handleRemove = (event, wishlist_id) => {
    event.stopPropagation();
    remove({ wishlist_id: wishlist_id });
  };

  return (
    <>
      <div className="py-4 px-3 shadow h-16 fixed top-0 z-50 bg-white dark:bg-zinc-900 w-full flex justify-between gap-4">
        <span className="flex gap-5 items-center">
          <ArrowBack onClick={() => navigate(-1)} />
          <p className="text-xl">My Wishlist</p>
        </span>
        <span className="flex gap-5 items-center ">
          <SearchModal />
          <WishlistButton /> <Checkout />
        </span>
      </div>

      <div className="flex-col flex px-2 my-[70px]">
        {isLoading ? (
          <div className="grid grid-cols-2 gap-[2px]">
            {[1, 2, 3, 4, 5, 6].map(() => {
              return (
                <Card
                  elevation={0}
                  className="!p-2 text-xs flex flex-col gap-2 !rounded-none !shadow"
                >
                  <Skeleton variant="rectangular" width={175} height={175} />
                  <Skeleton />
                  <Skeleton width="60%" />
                  <Skeleton>
                    <Rating />
                  </Skeleton>
                </Card>
              );
            })}
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-[2px]">
            {myWishList?.data?.data?.wishlist_product_list?.map((product) => {
              return (
                <Card
                  elevation={0}
                  className="!p-2 !rounded-none !shadow"
                  onClick={() =>
                    navigate(`/product/${product.product_id}/${product.slug}`)
                  }
                >
                  <div className="flex">
                    <img
                      src={product.variant_image}
                      alt=""
                      width={175}
                      height={175}
                    />
                    <DeleteOutline
                      className="-ml-8 shadow mt-1 p-1 !text-3xl bg-white dark:bg-zinc-900 rounded-full"
                      onClick={(event) => {
                        handleRemove(event, product.wishlist_id);
                      }}
                    />
                  </div>
                  <div className="flex flex-col gap-1 p-1 py-2">
                    <p className="text-sm w-40 overflow-hidden whitespace-nowrap text-ellipsis font-semibold">
                      {product.title}
                    </p>
                    <span className="flex text-xs items-center gap-1">
                      <p
                        className={classNames(
                          "line-through",
                          product.discount_percent === "0.0" ? "hidden" : ""
                        )}
                      >
                        {product.price}
                      </p>
                      <p className="font-semibold"> ₹{product.actual_price}</p>
                      <span
                        className={classNames(
                          "text-green-700",
                          product.discount_percent === "0.0" ? "hidden" : ""
                        )}
                      >
                        {product.discount_percent}% off
                      </span>
                    </span>

                    {/* <div className="flex py-2 w-full">
                      <div className="flex text-center flex-col bg-[#DEFEDA] rounded-r-md py-1">
                        <div className="border-r text-xs border-dashed border-green-500 text-black py-1 px-2">
                          <p>₹{product.actual_price / 10}</p>
                        </div>
                      </div>
                      <div className="flex justify-center bg-[#DEFEDA] items-center rounded-l-md w-full">
                        <p className="text-xs font-semibold">
                          Coupon Available
                        </p>
                      </div>
                    </div> */}
                    <Rating
                      value={product.rating}
                      size="small"
                      readOnly
                      precision={0.5}
                      className="!text-green-700"
                    />
                  </div>
                </Card>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};
export default MyWishList;
